// extracted by mini-css-extract-plugin
module.exports = {"standardContainer":"StandardContainer-module--standardContainer--3-cvo"};